import * as React from "react";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
const progressClass = css({
    position: "relative",
    overflow: "auto",
    maxWidth: "100%",
    display: "block",
    boxSizing: "border-box",
});
const progressContainerClass = css({
    position: "relative",
    margin: "6px",
    borderRadius: "5px",
    overflow: "hidden",
});
const progressBarClass = css({
    height: "10px",
    width: "100%",
    borderRadius: "5px",
    backgroundColor: getThemeColorVar("background", "light"),
});
const progressIndicatorClass = css({
    backgroundColor: getThemeColorVar("secondary1", "default"),
    position: "absolute",
    transform: "translateY(-100%)",
    left: 0,
    height: "10px",
    borderRadius: "5px",
    minWidth: "2%",
});
const progressBarCanceledClass = css({
    backgroundColor: getThemeColorVar("negative", "light"),
});
const progressIndicatorCanceledClass = css({
    backgroundColor: getThemeColorVar("negative", "default"),
});
export const Progress = (props) => {
    const progressIndicatorClasses = [progressIndicatorClass];
    const progressBarClasses = [progressBarClass];
    progressIndicatorClasses.push(css({
        width: `${props.percent}%`,
    }));
    if (props.additionalStyle) {
        progressIndicatorClasses.push(progressIndicatorCanceledClass);
        progressBarClasses.push(progressBarCanceledClass);
    }
    return (React.createElement("div", { className: cx(progressClass) },
        React.createElement("div", { className: cx(progressContainerClass) },
            React.createElement("div", { className: cx(progressBarClasses) }),
            React.createElement("div", { className: cx(progressIndicatorClasses) }))));
};
export default Progress;
//# sourceMappingURL=progress.js.map